import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconUpload = (props) => (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", focusable: false, ...props, children: [_jsx("path", { d: "M11 15h2V9h3l-4-5-4 5h3z" }, void 0), _jsx("path", { d: "M20 18H4v-7H2v7c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-7h-2v7z" }, void 0)] }, void 0));
const Memo = memo(SvgIconUpload);
export default Memo;
//# sourceMappingURL=IconUpload.js.map